import { request } from "./request.js";
/**
 * request方法参数
 * @param (请求地址, 请求方法, 请求参数)
 */
class reqApi {
  // 登录
  static userLogin(data) {
    return request(`/user/pcLogin`, "post", data);
  }

  // 妆容选择
  static makeupQuestion(data) {
    return request(`/tablet/makeupQuestion`, "get", data);
  }
  // 饮品选择
  static drinkQuestion(data) {
    return request(`/tablet/drinkQuestion`, "get", data);
  }
  // 饮品选择
  static colorQuestion(data) {
    return request(`/tablet/colorQuestion`, "get", data);
  }
   // 订单列表
  static orderQuestion(data) {
    return request(`/tablet/todayOrderList`, "get", data);
  }
}

export default reqApi;
